import fr from 'facet-rest';
import TextFieldLabelInline from 'Components/UI/TextFieldLabelInline';

export const AssumptionAdminOverride = fr.metaOverride()
  .overrideAll({
    _component: () => TextFieldLabelInline,
  });
